import React, { useState, useEffect } from 'react';
import { Box, Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const CodeEditor = ({
                        value,
                        onChange,
                        language = 'javascript',
                        onLanguageChange,
                        customFunctionName,
                        ...otherProps
                    }) => {
    const [code, setCode] = useState(value || '');

    useEffect(() => {
        setCode(value || '');
    }, [value]);

    const handleChange = (newValue) => {
        setCode(newValue);
        if (onChange) {
            onChange(newValue);
        }
    };

    // Base templates for different languages
    const getTemplate = (lang) => {
        const functionName = customFunctionName || 'customFunction';
        const templates = {
            javascript: `function ${functionName}(param1, param2) {
  // Your code here
  return {
    success: true,
    result: param1 + param2
  };
}`,
            python: `def ${functionName.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)}(param1, param2):
    """
    Your function here
    """
    return {
        'success': True,
        'result': param1 + param2
    }`,
            typescript: `function ${functionName}(param1: number, param2: number): object {
  // Your code here
  return {
    success: true,
    result: param1 + param2
  };
}`
        };
        return templates[lang] || '';
    };

    const insertTemplate = () => {
        if (!code.trim()) {
            handleChange(getTemplate(language));
        }
    };

    // Filter props to avoid React warnings
    const { customFunctionName: _, ...textareaProps } = otherProps;

    return (
        <Box>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1 }}>
                <FormControl size="small">
                    <InputLabel>Language</InputLabel>
                    <Select
                        label="Language"
                        value={language}
                        onChange={(e) => {
                            if (onLanguageChange) onLanguageChange(e.target.value);
                        }}
                        sx={{ minWidth: 160 }}
                    >
                        <MenuItem value="javascript">JavaScript</MenuItem>
                        <MenuItem value="typescript">TypeScript</MenuItem>
                        <MenuItem value="python">Python</MenuItem>
                    </Select>
                </FormControl>
            </Box>

            <textarea
                value={code}
                onChange={(e) => handleChange(e.target.value)}
                style={{
                    width: '100%',
                    minHeight: '300px',
                    fontFamily: 'Consolas, Monaco, "Courier New", monospace',
                    fontSize: '14px',
                    lineHeight: '1.5',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '12px',
                    resize: 'vertical',
                    boxSizing: 'border-box'
                }}
                placeholder={`Enter your ${language} code here...`}
                {...textareaProps}
            />

            <Box sx={{ mt: 1, display: 'flex', gap: 1 }}>
                <button
                    type="button"
                    onClick={insertTemplate}
                    style={{
                        fontSize: '12px',
                        padding: '4px 8px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        background: '#f5f5f5',
                        cursor: 'pointer'
                    }}
                >
                    Insert Template
                </button>
            </Box>
        </Box>
    );
};

export default CodeEditor;